'use client'

import * as React from 'react'
import { Typography } from '../typography'

import { SearchInput } from './search-input'
import { ImportantNotice } from '../demo/important-notice'
import { CodeExample } from '../demo/code-example'
import { DemoTabs } from '../demo/demo-tabs'

export function SearchInputDemo() {
  const [value, setValue] = React.useState('')
  return (
    <div className="space-y-2">
      <Typography variant="cf-heading-02" className="text-cf-grey-900">
        Search Input
      </Typography>
      <DemoTabs
        tabs={{
          preview: (
            <>
              <ImportantNotice type="warning">
                This component did not go through the official design system process but is still
                useful for cataloging and reuse.
              </ImportantNotice>
              <div className="space-y-6">
                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-grey-900 mb-4">
                    Basic Usage
                  </Typography>
                  <div className="space-y-4">
                    <div className="flex flex-col gap-4 max-w-md">
                      <SearchInput
                        value={value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          setValue(e.target.value)
                        }
                        // oxlint-disable-next-line no-alert
                        onSearch={() => alert(`Searching for: ${value}`)}
                        placeholder="Search for something..."
                      />
                    </div>
                    <CodeExample
                      code={`import { SearchInput } from '@repo/design-system-cf/components/input/search-input'
import * as React from 'react'

function Example() {
  const [value, setValue] = React.useState('')
  return (
    <SearchInput
      value={value}
      onChange={e => setValue(e.target.value)}
      onSearch={() => alert('Searching for: ' + value)}
      placeholder="Search for something..."
    />
  )
}`}
                    />
                  </div>
                </div>
              </div>
            </>
          ),
          api: {
            properties: [
              {
                name: 'value',
                type: 'string',
                defaultValue: '',
                description: 'The current value of the input',
              },
              {
                name: 'onChange',
                type: '(e: React.ChangeEvent<HTMLInputElement>) => void',
                defaultValue: 'undefined',
                description: 'Callback when the input value changes',
              },
              {
                name: 'onSearch',
                type: '() => void',
                defaultValue: 'undefined',
                description: 'Callback when the search is triggered (Enter key or icon click)',
              },
              {
                name: 'placeholder',
                type: 'string',
                defaultValue: '"Search..."',
                description: 'Placeholder text for the input',
              },
              {
                name: 'className',
                type: 'string',
                defaultValue: 'undefined',
                description: 'Additional CSS classes to apply',
              },
              {
                name: 'onKeyDown',
                type: '(e: React.KeyboardEvent<HTMLInputElement>) => void',
                defaultValue: 'undefined',
                description: 'Callback for key down events',
              },
              // ...other standard input props
            ],
          },
          changelog: [
            {
              date: '2024-05-01',
              changes: [
                'Initial version. Added to Pre-Design System Components catalog.',
                'Supports value, onChange, onSearch, placeholder, and standard input props.',
              ],
            },
          ],
        }}
      />
    </div>
  )
}
